import React from 'react';

const WarningIcon = (props) => {
  return (
    <svg
      data-name='Layer 2'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 33.43 40'
      className={props.className || null}
      style={{
        height: props.height ? `${props.height}px` : '',
        width: props.width ? `${props.width}px` : ''
      }}
    >
      <path
        d='m33.43 36.01-12.16.04c-.26 2.23-2.13 3.96-4.41 3.96s-4.14-1.71-4.41-3.92l-12.4.04-.05-2.2 4.16-4.2V16.56c0-5.81 4.26-10.62 9.79-11.41V3.37c0-1.84 1.17-3.34 2.61-3.34h.4c1.41 0 2.56 1.47 2.56 3.28v1.83c5.5.72 9.74 5.48 9.74 11.24v13.18l4.13 4.17.04 2.31Z'
        style={{ fill: '#ff6060' }}
        data-name='Layer 1'
      />
    </svg>
  );
};

export default WarningIcon;
